import { Controller } from "@hotwired/stimulus"

// Keyboard navigation for the flat list view. Roving tabindex over the
// event cards: Up/Down move between events, Home/End jump to first/last,
// Page Up/Down jump between month sections. Enter is left to the native
// link inside each item.
export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.setRoving(0)
    this.onKeydown = this.handleKeydown.bind(this)
    this.element.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.onKeydown)
  }

  handleKeydown(event) {
    const items = this.itemTargets
    const current = event.target.closest("[data-event-list-target=item]")
    const index = items.indexOf(current)
    if (index === -1) return

    switch (event.key) {
      case "ArrowDown": event.preventDefault(); this.focusIndex(index + 1); break
      case "ArrowUp":   event.preventDefault(); this.focusIndex(index - 1); break
      case "Home":      event.preventDefault(); this.focusIndex(0); break
      case "End":       event.preventDefault(); this.focusIndex(items.length - 1); break
      case "PageDown":  event.preventDefault(); this.focusIndex(this.nextMonthIndex(index)); break
      case "PageUp":    event.preventDefault(); this.focusIndex(this.previousMonthIndex(index)); break
    }
  }

  focusIndex(index) {
    const items = this.itemTargets
    const clamped = Math.max(0, Math.min(index, items.length - 1))
    this.setRoving(clamped)
    items[clamped].focus()
  }

  // First item of the next month group; the last item if none follows.
  nextMonthIndex(from) {
    const items = this.itemTargets
    const month = items[from].dataset.month
    const next = items.findIndex((el, i) => i > from && el.dataset.month !== month)
    return next === -1 ? items.length - 1 : next
  }

  // First item of the current month group; if already there, the first item
  // of the previous month group.
  previousMonthIndex(from) {
    const items = this.itemTargets
    const month = items[from].dataset.month
    let firstOfCurrent = from
    while (firstOfCurrent > 0 && items[firstOfCurrent - 1].dataset.month === month) firstOfCurrent--
    if (firstOfCurrent < from || firstOfCurrent === 0) return firstOfCurrent

    const prevMonth = items[firstOfCurrent - 1].dataset.month
    let firstOfPrev = firstOfCurrent - 1
    while (firstOfPrev > 0 && items[firstOfPrev - 1].dataset.month === prevMonth) firstOfPrev--
    return firstOfPrev
  }

  setRoving(activeIndex) {
    this.itemTargets.forEach((el, i) => el.setAttribute("tabindex", i === activeIndex ? "0" : "-1"))
  }
}
